import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AlertModule } from '@nx-fe/alert';
import { InsMaterialModule } from '@nx-fe/ins-material';
import { PipesModule, SaI18nPipe, XsI18nPipe } from '@nx-fe/pipes';
import { PopupMenuComponent } from '@nx-fe/popup-menu';
import { XSi18nService } from '@nx-fe/services';
import { UpdatingTimeModule } from '@nx-fe/updating-time';
import { PopupModule } from '@soti/popup';
import { TooltipModule } from '@soti/tooltip';
import { AgGridModule } from 'ag-grid-angular';
import { PromptDialogComponent } from 'xsshared/components/prompt-dialog/prompt-dialog.component';
import { CardItemComponent } from './components/card/card-item/card-item.component';
import { CardComponent } from './components/card/card.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { CellRendererComponent } from './components/dynamic-table/cell-renderer/cell-renderer.component';
import { DynamicTableComponent } from './components/dynamic-table/dynamic-table.component';
import { HeaderCellRendererComponent } from './components/dynamic-table/header-cell-renderer/header-cell-renderer.component';
import { EllipsisComponent } from './components/ellipsis/ellipsis.component';
import { KeyValueTableComponent } from './components/key-value-table/key-value-table.component';
import { ReporterCardComponent } from './components/reporter-card/reporter-card.component';
import { SaveCancelBarComponent } from './components/save-cancel-bar/save-cancel-bar.component';
import { SearchAndPickComponent } from './components/search-and-pick-V1/search-and-pick.component';
import { SearchAndPickV2Component } from './components/search-and-pick/search-and-pick.component';
import { SearchDropdownComponent } from './components/search-dropdown/src/search-dropdown.component';
import { StaticBannerComponent } from './components/static-banner/static-banner.component';
import { TextInput2Component } from './components/text-input-2/src/text-input.component';
import { TextInputComponent } from './components/text-input/text-input.component';
import { ToastComponent } from './components/toast/toast.component';
import { UserBadgeComponent } from './components/user-badge/user-badge.component';
import { UserBadgeService } from './components/user-badge/user-badge.service';
import { UserInfoPopupComponent } from './components/user-info-popup/user-info-popup.component';
import { StopPropagationDirective } from './directives/stop-propagation.directive';
import { MatOptionDisplayWrapperPipe } from './pipes/sa-matoptiondisplaywrapper.pipe';
import { ShortDateFormatPipe } from './pipes/time-format.pipe';
import { DayOfWeekPipe } from './pipes/week-day.pipe';
import { ToggleSwitchButtonModule } from './components/toggle-switch-button/toggle-switch-button.module';

@NgModule({
  declarations: [
    TextInputComponent,
    TextInput2Component,
    SearchDropdownComponent,
    MatOptionDisplayWrapperPipe,
    ShortDateFormatPipe,
    DayOfWeekPipe,
    EllipsisComponent,
    ConfirmationDialogComponent,
    SaveCancelBarComponent,
    StaticBannerComponent,
    UserBadgeComponent,
    SearchAndPickV2Component,
    SearchAndPickComponent,
    ToastComponent,
    DynamicTableComponent,
    KeyValueTableComponent,
    CardComponent,
    CardItemComponent,
    CellRendererComponent,
    ReporterCardComponent,
    UserInfoPopupComponent,
    PopupMenuComponent,
    HeaderCellRendererComponent,
    StopPropagationDirective,
    PromptDialogComponent,
  ],
  imports: [
    UpdatingTimeModule,
    CommonModule,
    FormsModule,
    ToggleSwitchButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatTooltipModule,
    MatInputModule,
    PipesModule,
    InsMaterialModule,
    AlertModule,
    AgGridModule,
    PopupModule,
    TooltipModule,
  ],
  exports: [
    TextInputComponent,
    TextInput2Component,
    UpdatingTimeModule,
    SearchDropdownComponent,
    ShortDateFormatPipe,
    DayOfWeekPipe,
    EllipsisComponent,
    ConfirmationDialogComponent,
    SaveCancelBarComponent,
    StaticBannerComponent,
    UserBadgeComponent,
    SearchAndPickV2Component,
    SearchAndPickComponent,
    ToastComponent,
    DynamicTableComponent,
    KeyValueTableComponent,
    CardComponent,
    CardItemComponent,
    ReporterCardComponent,
    UserInfoPopupComponent,
    PopupMenuComponent,
    HeaderCellRendererComponent,
    StopPropagationDirective,
    PromptDialogComponent,
    ToggleSwitchButtonModule
  ],
  providers: [
    XsI18nPipe,
    SaI18nPipe,
    MatOptionDisplayWrapperPipe,
    ShortDateFormatPipe,
    DayOfWeekPipe,
    XSi18nService,
    UserBadgeService,
    StopPropagationDirective,
    DecimalPipe,
  ],
})
export class SharedComponentsModule {}
